import { Info, SubmitButtonWrapper } from './styles'
import { Field, FieldProps } from 'formik'
import Button from 'components/Button'
import { useTranslation } from 'react-i18next'

interface IProps {
  text: string,
  hideInfo?: boolean,
  alignSelf?: string,
  justifyContent?: string,
  loading?: boolean,
  usingFormik?: boolean,
  onClick?: () => void,
  disabled?: boolean,
  noBottomMargin?: boolean,
  className?: string
}

const SubmitButton = (props: IProps) =>
  props.usingFormik ?
    <Field>
      {(fieldProps: FieldProps) =>
        <SubmitButtonContent
          {...props}
          onClick={props.onClick || fieldProps.form.handleSubmit}
          disabled={props.disabled !== undefined ? props.disabled : !fieldProps.form.isValid}
        />
      }
    </Field> :
    <SubmitButtonContent
      {...props}
    />

SubmitButton.defaultProps = {
  hideInfo: true,
  loading: false,
  usingFormik: true
}

const SubmitButtonContent = (props: IProps) => {
  const { t } = useTranslation()
  const { text, hideInfo, alignSelf, justifyContent, loading, onClick, disabled,
    className, noBottomMargin } = props

  return (
    <SubmitButtonWrapper
      alignSelf={alignSelf}
      justifyContent={justifyContent}
      noBottomMargin={noBottomMargin}
    >
      <Button
        className={className}
        size='large'
        onClick={onClick}
        disabled={disabled}
        loading={loading}
      >
        {text}
      </Button>

      { !hideInfo &&
        <Info>{t('global.or-press')} <b>{t('global.enter')}</b></Info>
      }
    </SubmitButtonWrapper>
  )
}

export default SubmitButton
